import { render, staticRenderFns } from "./ListReleaseItem.vue?vue&type=template&id=34d2e401&"
import script from "./ListReleaseItem.vue?vue&type=script&lang=js&"
export * from "./ListReleaseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListReleaseItem.vue"
export default component.exports